<div class="top-bar">
  <div class="container d-flex justify-content-between align-items-center d-flex-mobile-col gap-1">
    <div class="info-item">
      <i class="fa-solid fa-phone text-primary"></i> 
      <span>+91 99999 99999</span>
      <span class="divider">|</span>
      <i class="fa-solid fa-envelope text-primary"></i> 
      <span>info&#64;kashivedicsewa.com</span>
    </div>
    <div class="info-item banner-text">
      🔱 Certified Kashi Scholars &amp; Real-time Video Stream
    </div>
  </div>
</div>

<header class="glass-header sticky-header">
  <div class="container d-flex justify-content-between align-items-center py-3">
    <!-- Logo -->
    <a routerLink="/" class="logo-area" (click)="closeMobileMenu()">
      <div class="logo-title">🔱 Kashi Vedic Sewa</div>
      <div class="logo-subtitle">Varanasi's Premium Ritual Platform</div>
    </a>

    <!-- Desktop Nav -->
    <nav class="nav-links">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
      <a routerLink="/pujas" routerLinkActive="active">Puja Services</a>
      <a routerLink="/about" routerLinkActive="active">Our Heritage</a>
      <a routerLink="/contact" routerLinkActive="active">Contact Us</a>
    </nav>

    <!-- Right Actions -->
    <div class="action-links d-flex align-items-center gap-3">
      <a routerLink="/cart" class="cart-btn" aria-label="View Cart">
        <i class="fa-solid fa-om cart-icon"></i>
        <span class="cart-badge" *ngIf="cartCount > 0">{{ cartCount }}</span>
      </a>
      <a href="https://wa.me/919999999999" target="_blank" class="btn btn-whatsapp hide-mobile">
        <i class="fa-brands fa-whatsapp"></i> Quick Booking
      </a>
      
      <!-- Hamburger -->
      <button class="hamburger-btn" (click)="toggleMobileMenu()" aria-label="Toggle menu">
        <i class="fa-solid" [ngClass]="mobileMenuOpen ? 'fa-xmark' : 'fa-bars'"></i>
      </button>
    </div>
  </div>

  <!-- Mobile Dropdown Nav -->
  <div class="mobile-nav" *ngIf="mobileMenuOpen">
    <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">Home</a>
    <a routerLink="/pujas" routerLinkActive="active" (click)="closeMobileMenu()">Puja Services</a>
    <a routerLink="/about" routerLinkActive="active" (click)="closeMobileMenu()">Our Heritage</a>
    <a routerLink="/contact" routerLinkActive="active" (click)="closeMobileMenu()">Contact Us</a>
    <a href="https://wa.me/919999999999" target="_blank" class="btn btn-whatsapp mb-2">
      <i class="fa-brands fa-whatsapp"></i> WhatsApp Booking
    </a>
  </div>
</header>
